var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import cn from "classnames";
import { filter } from "ramda";
import ItemModalContainer from "containers/online_ordering/item_modal_container";
import { formatMoneyFromCents } from "helpers/money";
import { generateThumbnailUrl, generateMainUrl, } from "helpers/online_ordering/image_url";
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showModal: false,
        };
        _this.handleShowModal = _this.handleShowModal.bind(_this);
        _this.handleCloseModal = _this.handleCloseModal.bind(_this);
        _this.handleAddItem = _this.handleAddItem.bind(_this);
        return _this;
    }
    MenuItem.prototype.handleShowModal = function () {
        var _a = this.props, createEditableItem = _a.createEditableItem, item = _a.item;
        createEditableItem(item);
        this.setState({ showModal: true });
    };
    MenuItem.prototype.handleCloseModal = function () {
        var onDeleteEditableItem = this.props.onDeleteEditableItem;
        this.setState({ showModal: false });
        onDeleteEditableItem();
    };
    MenuItem.prototype.handleAddItem = function (item) {
        var onAddItem = this.props.onAddItem;
        onAddItem(item);
        this.handleCloseModal();
    };
    MenuItem.prototype.render = function () {
        var item = this.props.item;
        var name = item.name, description = item.description, price = item.price, images = item.images, stockLevel = item.stockLevel, minSides = item.minSides;
        var showModal = this.state.showModal;
        var thumbUrl;
        var mainUrl;
        if (images && images.onlineOrderingMenu && images.onlineOrderingMenu.main) {
            thumbUrl = generateThumbnailUrl(images.onlineOrderingMenu.main);
            mainUrl = generateMainUrl(images.onlineOrderingMenu.main);
        }
        var modal;
        if (showModal) {
            modal = (React.createElement(ItemModalContainer, { onAddItem: this.handleAddItem, onClose: this.handleCloseModal, imageUrl: mainUrl }));
        }
        var image;
        if (thumbUrl) {
            image = (React.createElement("img", { className: "thumbnail", src: thumbUrl, alt: name + " thumbnail" }));
        }
        var numInStockSides = filter(function (side) {
            return side.stockLevel.match({
                Just: function (stock) {
                    return stock > 0;
                },
                Nothing: function () { return true; },
            });
        })(item.sides).length;
        var hasEnoughRequireSides = minSides > 0 ? numInStockSides >= minSides : true;
        var isOutOfStock = function () {
            var topLevelItemInStock = stockLevel.match({
                Just: function (stock) {
                    return stock > 0;
                },
                Nothing: function () { return true; },
            });
            return !topLevelItemInStock || !hasEnoughRequireSides;
        };
        return (React.createElement("div", { className: cn("menu-item", { "out-of-stock": isOutOfStock() }), onClick: isOutOfStock() ? undefined : this.handleShowModal },
            React.createElement("div", { className: "content-box" },
                React.createElement("div", { className: "name" }, name),
                React.createElement("div", { className: "description" }, description),
                React.createElement("div", { className: "price" }, isOutOfStock() ? "Out of Stock" : formatMoneyFromCents(price))),
            image,
            modal));
    };
    return MenuItem;
}(React.Component));
export default MenuItem;
